(function() {
  function initTabs(tabsContainer) {
    const sectionId = tabsContainer.dataset.sectionId;
    const section = document.querySelector(`#collection-${sectionId}`);
    if (!section) return;

    const tabs = tabsContainer.querySelectorAll('.tabbed-collection__tab');
    const panels = section.querySelectorAll('.tabbed-collection__panel');

    if (tabs.length === 0 || panels.length === 0) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Get fresh references to ensure we're working with current DOM
        const allTabs = tabsContainer.querySelectorAll('.tabbed-collection__tab');
        const allPanels = section.querySelectorAll('.tabbed-collection__panel');
        
        // Update active tab
        allTabs.forEach((t, i) => {
          if (i === index) {
            t.classList.add('tabbed-collection__tab--active');
          } else {
            t.classList.remove('tabbed-collection__tab--active');
          }
        });

        // Update active panel
        allPanels.forEach((panel, i) => {
          if (i === index) {
            panel.classList.add('tabbed-collection__panel--active');
          } else {
            panel.classList.remove('tabbed-collection__panel--active');
          }
        });
      });
    });
  }

  function initializeAllTabs() {
    document.querySelectorAll('.tabbed-collection__tabs[data-section-id]').forEach(tabsContainer => {
      initTabs(tabsContainer);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllTabs);
  } else {
    initializeAllTabs();
  }

  // Handle Shopify theme editor section loading
  document.addEventListener('shopify:section:load', (event) => {
    setTimeout(() => {
      const sectionId = event.detail.sectionId;
      const tabsContainer = document.querySelector(`.tabbed-collection__tabs[data-section-id="${sectionId}"]`);
      if (tabsContainer) {
        initTabs(tabsContainer);
      }
    }, 100);
  });
})();

